(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sadhoo-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    // The store's own money_format shows "Rs." — an Admin-only
    // setting with no API mutation to change it (checked). ₹ is forced here
    // instead, at the theme layer, to match `sadhoo-price.liquid` (the
    // Liquid-side equivalent used everywhere else prices render server-side).
    function formatMoney(cents) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      const rupees = Math.round(cents / 100);
      return '₹' + rupees.toLocaleString('en-IN');
    }

    // A cart line's total — "Free", the struck list price beside the offer
    // price while the Launch Offer discount is on the cart, or the plain
    // total. Mirrors snippets/sadhoo-line-price.liquid (the server-rendered
    // version of the same cell), including reading the effective discount
    // rate back off the cart instead of hardcoding 10% — keep the two in
    // sync. Per-line amounts are rounded to whole rupees, so a multi-product
    // bag can differ from the exact subtotal by ₹1.
    function lineTotalHtml(item, discountRate) {
      if (item.final_line_price === 0) return 'Free';
      if (discountRate > 0 && item.original_line_price > 0) {
        const wasRupees = item.original_line_price / 100;
        const nowRupees = wasRupees - Math.round(wasRupees * discountRate);
        return (
          '<s class="sadhoo-line-price__was">₹' + Math.round(wasRupees).toLocaleString('en-IN') + '</s>' +
          '<span class="sadhoo-line-price__now">₹' + Math.round(nowRupees).toLocaleString('en-IN') + '</span>'
        );
      }
      return formatMoney(item.final_line_price);
    }

    const scrim = document.querySelector('[data-sadhoo-cart-scrim]');
    const drawer = document.querySelector('[data-sadhoo-cart-drawer]');
    if (!drawer) return;

    // The hidden "Free Tester (8ML) — Sadhoo" product's id — its line
    // items are labeled "<fragrance> Tester" / "8ML" here instead of the
    // product's own title/variant name, matching sadhoo-cart-line.liquid
    // (the server-rendered version of this same line, kept in sync with
    // it — see that file's own doc comment).
    const SADHOO_TESTER_PRODUCT_ID = 9296546136202;

    function isTesterItem(item) {
      return item.product_id === SADHOO_TESTER_PRODUCT_ID;
    }

    // Promotional rule: testers exist to build awareness of the rest of
    // the range, not to be taken for free on their own — so the cart can
    // never hold more free testers than paid 50ml bottles.
    function cartTotals(cart) {
      let bottles = 0;
      let testers = 0;
      cart.items.forEach((item) => {
        if (isTesterItem(item)) testers += item.quantity;
        else bottles += item.quantity;
      });
      return { bottles, testers };
    }

    // Whenever bottles are removed/reduced (or testers otherwise end up
    // outnumbering them), silently trim the newest tester lines first via
    // /cart/change.js until testers <= bottles. No confirmation needed —
    // this only ever removes free items, never something paid for.
    function enforceTesterCap(cart) {
      const { bottles, testers } = cartTotals(cart);
      let excess = testers - bottles;
      if (excess <= 0) return Promise.resolve(cart);

      const testerLines = cart.items.filter(isTesterItem).slice().reverse();
      let chain = Promise.resolve(cart);
      testerLines.forEach((line) => {
        if (excess <= 0) return;
        const reduceBy = Math.min(excess, line.quantity);
        excess -= reduceBy;
        chain = chain.then(() =>
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: line.quantity - reduceBy })
          }).then((r) => r.json())
        );
      });
      return chain;
    }

    const lines = drawer.querySelector('[data-sadhoo-cart-lines]');
    const empty = drawer.querySelector('[data-sadhoo-cart-empty]');
    const footer = drawer.querySelector('[data-sadhoo-cart-footer]');
    const subtotalEl = drawer.querySelector('[data-sadhoo-cart-subtotal]');
    const subtotalWasEl = drawer.querySelector('[data-sadhoo-cart-subtotal-was]');
    const saveRow = drawer.querySelector('[data-sadhoo-cart-save]');
    const saveAmountEl = drawer.querySelector('[data-sadhoo-cart-save-amount]');
    const countLabels = document.querySelectorAll('[data-sadhoo-cart-count-label]');
    const bagLink = document.querySelector('[data-sadhoo-cart-open]');
    const testerPromo = drawer.querySelector('[data-sadhoo-cart-tester-promo]');
    const testerPromoCopy = testerPromo && testerPromo.querySelector('[data-sadhoo-cart-tester-promo-copy]');
    const testerPromoPicker = testerPromo && testerPromo.querySelector('[data-sadhoo-cart-tester-promo-picker]');

    // Someone who "+"s a bottle straight from the shop grid never sees the
    // PDP's tester picker, so the drawer surfaces the same free-tester
    // offer itself whenever there's a bottle in the cart — and once every
    // slot is claimed, explains why the offer (and each tester line's "+")
    // is capped instead of just disappearing.
    function updateTesterPromo(totals) {
      if (!testerPromo) return;
      if (totals.bottles <= 0) {
        testerPromo.hidden = true;
        return;
      }
      testerPromo.hidden = false;
      const remaining = Math.max(0, totals.bottles - totals.testers);
      const atCap = remaining <= 0;
      testerPromo.classList.toggle('sadhoo-cart-tester-promo--capped', atCap);
      if (testerPromoPicker) testerPromoPicker.hidden = atCap;
      if (testerPromoCopy) {
        testerPromoCopy.textContent = atCap
          ? "You've claimed your FREE testers — add another 50ml bottle to unlock one more."
          : (remaining === 1
            ? 'Add 1 FREE tester of your choice.'
            : 'Add up to ' + remaining + ' FREE testers of your choice.');
      }
    }

    function lineTemplate(item, testersAtCap, discountRate) {
      const isTester = isTesterItem(item);
      const name = isTester ? item.variant_title + ' Tester' : item.product_title;
      const variantLine = isTester
        ? '<span class="sadhoo-cart-line__variant">8ML</span>'
        : (item.variant_title && item.variant_title !== 'Default Title'
          ? '<span class="sadhoo-cart-line__variant">' + item.variant_title + '</span>'
          : '');
      const media = item.image
        ? '<span class="sadhoo-cart-line__media" style="background-image:url(' + item.image + '&width=200)"></span>'
        : '<span class="sadhoo-cart-line__media"></span>';
      const lineTotal = lineTotalHtml(item, discountRate);
      return (
        '<div class="sadhoo-cart-line" data-sadhoo-cart-line data-line-key="' + item.key + '">' +
          media +
          '<div class="sadhoo-cart-line__info">' +
            '<div class="sadhoo-cart-line__row">' +
              '<a href="' + item.url + '" class="sadhoo-cart-line__name">' + name + '</a>' +
              '<span class="sadhoo-cart-line__total" data-sadhoo-cart-line-total>' + lineTotal + '</span>' +
            '</div>' +
            variantLine +
            '<div class="sadhoo-cart-line__actions">' +
              '<div class="sadhoo-cart-line__qty">' +
                '<button type="button" data-sadhoo-cart-qty-decrease aria-label="Decrease quantity">&minus;</button>' +
                '<span data-sadhoo-cart-qty-value>' + item.quantity + '</span>' +
                '<button type="button" data-sadhoo-cart-qty-increase aria-label="Increase quantity"' + (isTester && testersAtCap ? ' disabled' : '') + '>+</button>' +
              '</div>' +
              '<button type="button" data-sadhoo-cart-remove class="sadhoo-cart-line__remove">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }

    function render(cart) {
      const totals = cartTotals(cart);
      const testersAtCap = totals.testers >= totals.bottles;
      const discountRate = cart.original_total_price > 0 ? cart.total_discount / cart.original_total_price : 0;
      lines.innerHTML = cart.items.map((item) => lineTemplate(item, testersAtCap, discountRate)).join('');
      updateTesterPromo(totals);
      const isEmpty = cart.item_count === 0;
      empty.hidden = !isEmpty;
      footer.hidden = isEmpty;
      subtotalEl.textContent = formatMoney(cart.total_price);
      // "10% launch offer" saving row + the struck list subtotal, shown only
      // while Shopify reports an actual discount on the cart.
      const discounted = cart.total_discount > 0;
      if (saveRow) saveRow.hidden = !discounted;
      if (saveAmountEl) saveAmountEl.textContent = formatMoney(cart.total_discount);
      if (subtotalWasEl) {
        subtotalWasEl.hidden = !discounted;
        subtotalWasEl.textContent = formatMoney(cart.original_total_price);
      }
      countLabels.forEach((el) => { el.textContent = '(' + cart.item_count + ')'; });
      const badgeParent = bagLink;
      if (badgeParent) {
        let badge = badgeParent.querySelector('.sadhoo-header__cart-count');
        if (cart.item_count > 0 && !badge) {
          badge = document.createElement('span');
          badge.className = 'sadhoo-header__cart-count';
          badgeParent.appendChild(badge);
        }
        if (badge) {
          badge.textContent = cart.item_count;
          badge.hidden = cart.item_count === 0;
        }
      }
    }

    function refreshCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then(enforceTesterCap)
        .then((cart) => { render(cart); return cart; });
    }

    function openDrawer() {
      document.querySelectorAll('.sadhoo-drawer-scrim').forEach((s) => s.classList.remove('is-visible'));
      document.querySelectorAll('.sadhoo-cart-drawer').forEach((d) => {
        d.classList.remove('is-open');
        d.setAttribute('aria-hidden', 'true');
      });
      if (scrim) { scrim.hidden = false; requestAnimationFrame(() => scrim.classList.add('is-visible')); }
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (scrim) {
        scrim.classList.remove('is-visible');
        setTimeout(() => { if (!scrim.classList.contains('is-visible')) scrim.hidden = true; }, 320);
      }
    }

    function addVariant(id, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id, quantity: quantity || 1 })
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error(data.description || data.message || 'Could not add to cart');
          return refreshCart();
        })
        .then((cart) => { openDrawer(); return cart; });
    }

    window.SadhooCart = { addVariant, refreshCart, open: openDrawer, close: closeDrawer };

    // Two-second confirmation on the control that just added to the bag.
    // Every `[data-added-text]` inside the form's `[data-sadhoo-add-btn]`
    // (and, on a home card, the card's `[data-sadhoo-add-status]` line)
    // swaps to that text and gets `.is-added`; the original text comes back
    // afterwards. Clicking again inside the window just restarts it.
    const ADDED_MS = 2000;

    function swapAddedText(el, on) {
      if (on) {
        if (!el.hasAttribute('data-original-text')) el.setAttribute('data-original-text', el.textContent);
        el.textContent = el.dataset.addedText;
      } else if (el.hasAttribute('data-original-text')) {
        el.textContent = el.getAttribute('data-original-text');
        el.removeAttribute('data-original-text');
      }
    }

    function setAdded(el, on) {
      el.classList.toggle('is-added', on);
      if (el.hasAttribute('data-added-text')) swapAddedText(el, on);
      el.querySelectorAll('[data-added-text]').forEach((part) => swapAddedText(part, on));
    }

    function flashAdded(form) {
      const card = form.closest('[data-sadhoo-add-card]');
      [form.querySelector('[data-sadhoo-add-btn]'), card && card.querySelector('[data-sadhoo-add-status]')].forEach((el) => {
        if (!el) return;
        clearTimeout(el._sadhooAddedTimer);
        setAdded(el, true);
        el._sadhooAddedTimer = setTimeout(() => setAdded(el, false), ADDED_MS);
      });
    }

    // Intercept every add-to-cart form on the site.
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('.sadhoo-shop-card__form, .sadhoo-range__quick-add-form, .sadhoo-pdp__form');
      if (!form) return;
      event.preventDefault();

      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      // A form can carry a "companion" variant to add alongside its own
      // line — e.g. the PDP's free-tester pick — via a hidden input with
      // this attribute. Bundling it into the same /cart/add.js call means
      // one add, one drawer-open, instead of the tester popping the drawer
      // the moment it's picked, before "Add to bag" is even clicked.
      const companionInput = form.querySelector('[data-sadhoo-companion-variant-id]');
      const companionVariantId = companionInput && companionInput.value ? companionInput.value : null;

      let addRequest;
      if (companionVariantId) {
        const mainId = form.querySelector('[name="id"]').value;
        const mainQtyInput = form.querySelector('[name="quantity"]');
        const mainQty = mainQtyInput ? (parseInt(mainQtyInput.value, 10) || 1) : 1;
        addRequest = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: mainId, quantity: mainQty },
              { id: companionVariantId, quantity: 1 }
            ]
          })
        });
      } else {
        const formData = new FormData(form);
        addRequest = fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
      }

      addRequest
        .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error(data.description || data.message || 'Could not add to cart');
          return refreshCart();
        })
        .then(() => {
          flashAdded(form);
          openDrawer();
        })
        .catch((err) => {
          // eslint-disable-next-line no-alert
          window.alert(err.message || 'Sorry, that item could not be added.');
        })
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
    });

    // Free-tester promo banner: adds the picked tester variant on its own
    // (no companion bottle — one's already in the cart, that's the point).
    if (testerPromo) {
      testerPromo.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-sadhoo-cart-tester-promo-add]');
        if (!btn) return;
        const select = testerPromo.querySelector('[data-sadhoo-cart-tester-promo-select]');
        if (!select || !select.value) return;
        const originalLabel = btn.textContent;
        btn.disabled = true;
        addVariant(select.value, 1)
          .catch((err) => {
            // eslint-disable-next-line no-alert
            window.alert(err.message || 'Sorry, that tester could not be added.');
          })
          .finally(() => {
            btn.disabled = false;
            btn.textContent = originalLabel;
          });
      });
    }

    // Open/close triggers.
    if (bagLink) {
      bagLink.addEventListener('click', (event) => {
        event.preventDefault();
        refreshCart().then(openDrawer);
      });
    }
    drawer.querySelectorAll('[data-sadhoo-cart-close]').forEach((btn) => btn.addEventListener('click', closeDrawer));
    if (scrim) scrim.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
    });

    // Qty +/- and remove, delegated from the lines container.
    lines.addEventListener('click', (event) => {
      const line = event.target.closest('[data-sadhoo-cart-line]');
      if (!line) return;
      const key = line.dataset.lineKey;
      const valueEl = line.querySelector('[data-sadhoo-cart-qty-value]');

      if (event.target.closest('[data-sadhoo-cart-remove]')) {
        updateLine(key, 0);
      } else if (event.target.closest('[data-sadhoo-cart-qty-increase]')) {
        updateLine(key, parseInt(valueEl.textContent, 10) + 1);
      } else if (event.target.closest('[data-sadhoo-cart-qty-decrease]')) {
        updateLine(key, Math.max(0, parseInt(valueEl.textContent, 10) - 1));
      }
    });

    function updateLine(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      })
        .then((r) => r.json())
        .then(enforceTesterCap)
        .then(render);
    }

    // First paint: sync with whatever the cart session actually holds
    // (SSR markup already matches on a fresh load, but this keeps the
    // header badge correct after any hot-reload / bfcache restore).
    refreshCart();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sadhoo-motion"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.documentElement;
    if (!root.classList.contains('sadhoo-motion')) return;

    const TRANSITION_MS = 640;
    const elements = Array.from(document.querySelectorAll('[data-sadhoo-reveal]'));

    // Stagger in threes, as in the design: 0 / 80 / 160ms by document order.
    elements.forEach((el, index) => {
      el.style.setProperty('--sadhoo-reveal-delay', (index % 3) * 80 + 'ms');
    });

    // Once an element has finished arriving, hand it back to its own CSS so
    // the reveal transition can never get in the way of a hover or press.
    function settle(el) {
      el.removeAttribute('data-sadhoo-reveal');
      el.classList.remove('is-revealed');
      el.style.removeProperty('--sadhoo-reveal-delay');
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          observer.unobserve(el);
          el.classList.add('is-revealed');
          const delay = parseFloat(el.style.getPropertyValue('--sadhoo-reveal-delay')) || 0;
          setTimeout(() => settle(el), TRANSITION_MS + delay + 120);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
    );

    elements.forEach((el) => observer.observe(el));
    root.setAttribute('data-sadhoo-motion', 'ready');
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sadhoo-wishlist"] && !Shopify.designMode) return;
  try {
    (function () {
    const STORAGE_KEY = 'sadhoo:wishlist';

    // Same heart silhouette as the header's wishlist nav icon (brand
    // consistency), stretched a little wider than its native 23x23 square
    // via preserveAspectRatio="none" rather than a squarer glyph.
    const HEART_OUTLINE = '<svg width="20" height="16.5" viewBox="0 0 23 23" fill="none" preserveAspectRatio="none" aria-hidden="true"><path d="M11.5 18.6C11.5 18.6 4 14.3 4 9.3A4.2 4.2 0 0 1 11.5 6.7A4.2 4.2 0 0 1 19 9.3C19 14.3 11.5 18.6 11.5 18.6Z" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round"/></svg>';
    const HEART_FILLED = '<svg width="20" height="16.5" viewBox="0 0 23 23" fill="currentColor" preserveAspectRatio="none" aria-hidden="true"><path d="M11.5 18.6C11.5 18.6 4 14.3 4 9.3A4.2 4.2 0 0 1 11.5 6.7A4.2 4.2 0 0 1 19 9.3C19 14.3 11.5 18.6 11.5 18.6Z" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round"/></svg>';

    function readWishlist() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {
        return [];
      }
    }

    function writeWishlist(ids) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
      } catch (e) {
        /* storage unavailable; toggle still works for this page view */
      }
    }

    function paint(button, active) {
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.innerHTML = active ? HEART_FILLED : HEART_OUTLINE;
    }

    function syncButtonsForProduct(id, active) {
      document
        .querySelectorAll('[data-sadhoo-wishlist-toggle][data-product-id="' + id + '"]')
        .forEach((button) => paint(button, active));
    }

    function paintHeaderCount(count) {
      document.querySelectorAll('[data-sadhoo-wishlist-count]').forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count === 0;
      });
    }

    function refreshToggles() {
      const wishlist = readWishlist();
      document.querySelectorAll('[data-sadhoo-wishlist-toggle]').forEach((button) => {
        paint(button, wishlist.includes(button.dataset.productId));
      });
      paintHeaderCount(wishlist.length);
    }

    // --- Drawer -------------------------------------------------------
    const scrim = document.querySelector('[data-sadhoo-wishlist-scrim]');
    const drawer = document.querySelector('[data-sadhoo-wishlist-drawer]');
    const catalogScript = document.querySelector('[data-sadhoo-product-catalog]');
    const catalog = catalogScript ? JSON.parse(catalogScript.textContent || '[]') : [];

    function catalogEntry(id) {
      return catalog.find((p) => String(p.id) === String(id));
    }

    function escapeHtml(text) {
      return String(text).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
    }

    function lineTemplate(product) {
      // "50ML · CEDAR · VETIVER": size, then the product's first two notes.
      const detail = [product.size, product.notes].filter(Boolean).join(' · ');
      return (
        '<div class="sadhoo-cart-line" data-sadhoo-wishlist-line data-product-id="' + product.id + '">' +
          '<a href="' + product.url + '" class="sadhoo-cart-line__media" style="background-image:url(' + product.image + '&width=200)"></a>' +
          '<div class="sadhoo-cart-line__info">' +
            '<div class="sadhoo-cart-line__row">' +
              '<a href="' + product.url + '" class="sadhoo-cart-line__name">' + product.title + '</a>' +
              // Struck list price + Launch Offer price, same classes as the
              // cart lines (sadhoo-line-price, styled in sadhoo-cart-drawer).
              '<span class="sadhoo-cart-line__total">' +
                (product.priceNow
                  ? '<s class="sadhoo-line-price__was">' + product.price + '</s><span class="sadhoo-line-price__now">' + product.priceNow + '</span>'
                  : product.price) +
              '</span>' +
            '</div>' +
            (detail ? '<span class="sadhoo-cart-line__variant">' + escapeHtml(detail) + '</span>' : '') +
            '<div class="sadhoo-cart-line__actions">' +
              '<button type="button" class="sadhoo-btn sadhoo-cart-line__add" data-sadhoo-wishlist-add data-variant-id="' + product.variantId + '"' +
                (product.available ? '' : ' disabled') +
              '>' + (product.available ? 'Add to bag' : 'Sold out') + '</button>' +
              '<button type="button" data-sadhoo-wishlist-remove class="sadhoo-cart-line__remove">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }

    function renderDrawer() {
      if (!drawer) return;
      const wishlist = readWishlist();
      const lines = drawer.querySelector('[data-sadhoo-wishlist-lines]');
      const empty = drawer.querySelector('[data-sadhoo-wishlist-empty]');
      const countLabel = drawer.querySelector('[data-sadhoo-wishlist-count-label]');
      const products = wishlist.map(catalogEntry).filter(Boolean);

      lines.innerHTML = products.map(lineTemplate).join('');
      lines.hidden = products.length === 0;
      empty.hidden = products.length > 0;
      if (countLabel) countLabel.textContent = '(' + products.length + ')';
    }

    function openDrawer() {
      if (!drawer) return;
      document.querySelectorAll('.sadhoo-drawer-scrim').forEach((s) => s.classList.remove('is-visible'));
      document.querySelectorAll('.sadhoo-cart-drawer').forEach((d) => {
        d.classList.remove('is-open');
        d.setAttribute('aria-hidden', 'true');
      });
      renderDrawer();
      if (scrim) { scrim.hidden = false; requestAnimationFrame(() => scrim.classList.add('is-visible')); }
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (scrim) {
        scrim.classList.remove('is-visible');
        setTimeout(() => { if (!scrim.classList.contains('is-visible')) scrim.hidden = true; }, 320);
      }
    }

    document.addEventListener('DOMContentLoaded', refreshToggles);

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-sadhoo-wishlist-toggle]');
      if (toggle) {
        event.preventDefault();
        const id = toggle.dataset.productId;
        const wishlist = readWishlist();
        const index = wishlist.indexOf(id);
        const nowActive = index === -1;
        if (nowActive) wishlist.push(id); else wishlist.splice(index, 1);
        writeWishlist(wishlist);
        syncButtonsForProduct(id, nowActive);
        paintHeaderCount(wishlist.length);
        return;
      }

      const navLink = event.target.closest('[data-sadhoo-wishlist-nav]');
      if (navLink && drawer) {
        event.preventDefault();
        openDrawer();
        return;
      }

      if (event.target.closest('[data-sadhoo-wishlist-close]')) {
        closeDrawer();
        return;
      }

      const removeBtn = event.target.closest('[data-sadhoo-wishlist-remove]');
      if (removeBtn) {
        const line = removeBtn.closest('[data-sadhoo-wishlist-line]');
        const id = line.dataset.productId;
        const wishlist = readWishlist().filter((existing) => existing !== id);
        writeWishlist(wishlist);
        syncButtonsForProduct(id, false);
        paintHeaderCount(wishlist.length);
        renderDrawer();
        return;
      }

      const addBtn = event.target.closest('[data-sadhoo-wishlist-add]');
      if (addBtn && window.SadhooCart) {
        window.SadhooCart.addVariant(addBtn.dataset.variantId, 1);
        closeDrawer();
      }
    });

    if (scrim) scrim.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
